import zxcvbn from "zxcvbn";

export const passwordStrength = (password) => {
  const { score } = zxcvbn(password || "");
  return score;
};
